/**
 * Provider display name utilities.
 *
 * Maps raw provider identifiers (e.g., "anthropic", "openai") to
 * human-readable display names for the UI.
 */

/** Known provider display names */
const PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  anthropic: 'Anthropic',
  openai: 'OpenAI',
  'openai-codex': 'OpenAI Codex',
  google: 'Google',
  'google-genai': 'Google Gemini',
  openrouter: 'OpenRouter',
  mistral: 'Mistral',
  groq: 'Groq',
  deepseek: 'DeepSeek',
  together: 'Together AI',
  fireworks: 'Fireworks',
  perplexity: 'Perplexity',
  cohere: 'Cohere',
  ollama: 'Ollama',
  minimax: 'MiniMax',
  moonshot: 'Moonshot',
  venice: 'Venice',
  nvidia: 'NVIDIA',
  huggingface: 'Hugging Face',
  vllm: 'vLLM',
  qianfan: 'Qianfan',
  xiaomi: 'Xiaomi',
  'cloudflare-ai-gateway': 'Cloudflare AI',
  'qwen-portal': 'Qwen',
  'minimax-portal': 'MiniMax Portal',
  synthetic: 'Synthetic',
};

/**
 * Format a raw provider identifier into a human-readable display name.
 *
 * Falls back to title-casing the identifier if not in the known list.
 */
export function formatProviderName(provider: string): string {
  const known = PROVIDER_DISPLAY_NAMES[provider];
  if (known) return known;

  // Title-case fallback: "my-provider" → "My Provider"
  return provider
    .split(/[-_]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
